import MyProfile from "../components/my-profile/my-profile";
import Layout from "@/components/layout/layout";
const MyProfilePage = () => {
  return (
    <div>
      <Layout>
        <MyProfile />
      </Layout>
    </div>
  );
};

export default MyProfilePage;
